module.exports = __webpack_public_path__ + "img/29.c460fb35.png";